/** @file handlePaint: a handle's colour this frame (its axis colour, or the hover colour). */
import type { Color3 } from '@babylonjs/core/Maths/math.color.js';
import type { GizmoFrame } from './gizmoFrame';
import { GIZMO_PALETTE as P } from './gizmoPalette';
import type { GizmoHandle } from './gizmoShape';

/** `GIZMO_PALETTE.handle[handle]`, or `hover` when it is the hovered or dragged one. */
export function handlePaint(f: GizmoFrame, handle: GizmoHandle): Color3 {
  return f.hover === handle ? P.hover : (P.handle[handle] ?? P.hover);
}
